<script>
  import { onMount } from "svelte";
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import alertify from "alertifyjs";
  import server from "../../../../server";
  import moment from "moment";
  import Loading from "../../Loading.svelte";
  import { ICONS } from "../../../../js/icons";

  export let showTrxLogs;
  export let logfilter;

  let logs = [];
  let groupedLogs = {};
  let selectedRid = "";
  let params = {};
  let loading = true;
  let viewMoreParams = {};
  let showMore = false;
  const fmtTs = (ts) => ts ? moment(ts).format("YYYY-MM-DD HH:mm:ss.SSS") : "";
  const lvlClass = (lvl) => {
      const v = (lvl || "").toUpperCase();
      return v === "ERROR" ? "lvl-error"
          : v === "WARN"  ? "lvl-warn"
              : v === "DEBUG" ? "lvl-debug"
                  : "lvl-info";
  };
  const highlight = (text, needle) => {
      if (!needle) return text;
      const esc = needle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return text.replace(new RegExp(esc, "gi"), (m) => `<mark>${m}</mark>`);
  };
  const extractJson = (s) => {
      if (!s || typeof s !== "string") return null;
      const start = s.indexOf("{"); const end = s.lastIndexOf("}");
      if (start === -1 || end === -1 || end <= start) return null;
      const raw = s.slice(start, end + 1);
      try { return { json: JSON.parse(raw), before: s.slice(0, start), after: s.slice(end + 1) }; }
      catch { return null; }
  };
  const computeTimestamp = (log) => {
      if (log?.timestamp) return String(log.timestamp);
      const parts = extractJson(log?.message);
      const ts = parts?.json?.timestamp || parts?.json?.["@timestamp"];
      return ts ? String(ts) : null;
  };
  const fmtTime = (isoTs) => isoTs ? moment(isoTs).format("HH:mm:ss.SSS") : "";

  const pretty = (obj) => JSON.stringify(obj, null, 2);
  const copy = async (txt) => {
      try { await navigator.clipboard.writeText(txt); alertify.success("Copiado"); }
      catch { alertify.error("No se pudo copiar"); }
  };

  onMount(async () => {
    if (typeof logfilter == "object") {
      params.search = logfilter.search;
      params.from = moment(logfilter.from).format("YYYY-MM-DD HH:mm");
      params.to = moment(logfilter.to).format("YYYY-MM-DD HH:mm");
      params.type = logfilter.type;
    } else {
      let actualDate = moment();
      params.search = "";
      let dateRest = actualDate.startOf("day");
      params.from = dateRest.format("YYYY-MM-DD HH:mm");
      params.to = moment().format("YYYY-MM-DD HH:mm");
    }
    params.nextTokenJava = "";
    params.nextTokenNode = "";
    const loadingPromise = listLogs();
    await loadingPromise;
    loading = false;
  });

  const listLogs = async () => {
      try {
          loading = true;
          const params_ = { ...params };
          params_.trxSearch = params_.search;
          params_.startDate = params_.from;
          params_.type = params_.type;
          const { data } = await server.logs.traceByCodeAndDates(params_);
          groupedLogs = data?.logs || {};
          const rids = Object.keys(groupedLogs);
          selectedRid = rids[0] || "";
          const arr = groupedLogs[selectedRid] || [];
          logs = arr.map((m, idx) => ({
              message: m.message || "",
              level: (m.level || "INFO"),
              timestamp: m.timestamp || null,
          }));
      } catch (error) {
          console.log(error);
          alertify.error("Error No se listo");
      } finally {
          loading = false;
      }
  };

  const formatLogs = async (logs_, new_logs, search) => {
    var list = [...logs_];
    if (search == "") {
      list = new_logs;
    } else {
      var regex = new RegExp(search, "g");
      list = new_logs.map((l) => {
        l = l.replace(
          regex,
          `<span style="background:#E9AD00;padding: 1px 0 0 1px">${search}</span>`
        );
        return l;
      });
    }
    var cleanLogs = list.map((l) => {
      l = l.replace(
        /^.*(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}.\d{3}).*\[nio-5000-exec-\d+] .+ :/,
        "<b>$1:</b>"
      );
      return l;
    });
    return cleanLogs;
  };

  const viewMore = async () => {
    try {
      showMore = true;

      const { data } = await server.trx.logs({ ...viewMoreParams });
      viewMoreParams.nextTokenJava = data.nextTokenJava;
      viewMoreParams.nextTokenNode = data.nextTokenNode;

      let logs_ = await formatLogs(logs, data.events, "");
      logs = logs.concat(logs_);
    } catch (error) {
      console.error("Error in viewMore function:", error);
    } finally {
      showMore = false;
    }
  };

  const onShowTrxLogs = () => (showTrxLogs = !showTrxLogs);

  $: firstReqId = selectedRid || "";
</script>

<Modal isOpen={showTrxLogs} toggle={onShowTrxLogs} size={"xl"}>
  <ModalHeader toggle={onShowTrxLogs}>Rastreo de Transacciones</ModalHeader>
  <ModalBody>
    <div class="wrapp">
        <!-- Banner before results -->
        {#if logs.length}
            <div class="result-banner">
                Resultados para <strong>{@html highlight((params.search), (params.search))}</strong> con Request-ID <strong>{firstReqId || "—"}</strong>
            </div>
        {/if}
      <div class="cont-data-log">
          {#if loading}
              <Loading/>
          {:else}
              {#if logs.length > 0}
              <div class="log-list">
                  {#each logs as log}
                      <article class="log-item">
                          <header class="log-meta">
                              <span class={"lvl " + lvlClass(log.level)}>{(log.level || "INFO").toUpperCase()}</span>
                              {#if computeTimestamp(log)}
                                  <span class="chip ts">{fmtTime(computeTimestamp(log))}</span>
                              {/if}
                              {#if log.service}<span class="svc" title="service-name">{log.service}</span>{/if}
                              {#if log.requestId}
                                  <button class="chip" title="Request-ID" on:click={() => copy(log.requestId)}>
                                      {log.requestId}
                                      <span class="chip-copy">⧉</span>
                                  </button>
                              {/if}
                              {#if log.index}<span class="idx" title="index">{log.index}</span>{/if}
                              {#if log.id}<span class="docid" title="_id">{log.id}</span>{/if}
                          </header>

                          {#if extractJson(log.message)}
                              {#key log.id}
                                  {#await (async () => extractJson(log.message))() then parts}
                                      <div class="msg">
                                          {@html highlight((parts.before || "").trim(), params.search)}
                                          <details class="json">
                                              <summary>Ver JSON</summary>
                                              <pre><code>{pretty(parts.json)}</code></pre>
                                          </details>
                                          {@html highlight((parts.after || "").trim(), params.search)}
                                      </div>
                                  {/await}
                              {/key}
                          {:else}
                              <div class="msg">
                                  {@html highlight(log.message || "", params.search)}
                              </div>
                          {/if}
                      </article>
                  {/each}
              </div>
              {:else}
                    <p>No se encontraron registros</p>
              {/if}
        {/if}
        <!--<div class="btn-view-more">
          <button on:click={viewMore} class="btn btn-primary btn-sm rigth"
            >Ver más</button >

        </div>-->
      </div>
    </div>
  </ModalBody>
</Modal>

<style>
  .wrapp {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
  .cont-data-log {
    width: 100%;
    background-color: rgb(255, 255, 255);
    border-radius: 0.5rem;
    border: 1px solid black;
    padding: 1rem;
    overflow: auto;
    min-height: 3.5rem;
    max-height: 65vh;
    position: relative;
  }
  .cont-data-log p {
    word-wrap: break-word;
  }
  .filter-logs {
    display: grid;
    grid-template-columns: 33% 20% 20% 20% 3%;
    align-items: center;
    width: 100%;
    gap: 0.3rem;
  }
  .cont-data-log p:nth-child(even) {
    background-color: rgba(242, 242, 242);
  }
  .cont-data-log p:hover {
    background-color: rgba(156, 164, 164);
    cursor: pointer;
  }
  .btn-view-more {
    display: flex;
    justify-content: right;
    align-items: center;
    gap: 0.5rem;
  }
  .log-list {
      display: flex; flex-direction: column; gap: .5rem;
  }
  .log-item {
      border: 1px solid #e3e3e3; border-radius: .5rem; padding: .5rem .75rem;
      background: #fff;
  }
  .log-meta {
      display: flex; flex-wrap: wrap; gap: .5rem .6rem; align-items: center;
      font-size: .82rem; margin-bottom: .4rem;
  }
  .ts { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; color: #444; }
  .lvl {
      padding: .05rem .4rem; border-radius: .75rem; font-weight: 700; letter-spacing: .02em;
      font-size: .72rem;
  }
  .lvl-info { background:#e8f1ff; color:#1158cc; }
  .lvl-debug{ background:#eef5ef; color:#2f7d32; }
  .lvl-warn { background:#fff5e6; color:#a66300; }
  .lvl-error{ background:#ffecec; color:#c62828; }
  .svc, .idx, .docid {
      font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
      background:#f6f6f6; border:1px solid #e6e6e6; border-radius:.35rem; padding:.05rem .35rem;
  }
  .chip {
      border:1px solid #e6e6e6; background:#f9f9f9; border-radius:.35rem; padding:.05rem .35rem;
      font-family: ui-monospace, SFMono-Regular, Menlo, monospace; cursor:pointer;
  }
  .chip:hover { background:#f0f0f0; }
  .chip-copy { opacity:.7; margin-left:.25rem; }

  .msg { white-space: pre-wrap; word-break: break-word; font-size: .9rem; }
  .json summary { cursor: pointer; user-select: none; margin:.25rem 0; }
  .json pre { margin: .35rem 0 0; padding:.5rem; background:#0f172a; color:#e2e8f0; border-radius:.35rem;
      overflow:auto; max-height: 40vh; }
</style>
